import * as MAD from "./import";
export default MAD;